import { FileRejectionState } from './getFilesToUpload';
import { ListItemIcon, Tooltip } from '@mui/material';
import {
  AddPhotoAlternateOutlined as AddImageIcon,
  PhotoLibraryOutlined as SelectImageIcon,
  PhotoCameraOutlined as TakePhotoIcon,
  WarningOutlined as WarningIcon,
} from '@mui/icons-material';
import MenuItemLoadingIndicator from '@/components/Menu/MenuItemLoadingIndicator';
import ErrorIcon from '../../utils/icons/ErrorIcon';
import { FormattedMessage } from 'react-intl';

type ImageUploadOptionIconProps = {
  variant: 'add_image_generic' | 'select_image' | 'take_photo';
  uploading: boolean;
  fileRejectionState: FileRejectionState;
};

const ImageUploadOptionIcon = ({
  variant,
  uploading,
  fileRejectionState,
}: ImageUploadOptionIconProps) => {
  const hasError =
    fileRejectionState === FileRejectionState.ONE_FILE_AND_REJECTED ||
    fileRejectionState === FileRejectionState.MULTIPLE_FILES_ALL_REJECTED;

  const hasWarning =
    fileRejectionState !== FileRejectionState.NONE_REJECTED && !hasError;

  return (
    <ListItemIcon>
      {uploading ? (
        <MenuItemLoadingIndicator />
      ) : hasError ? (
        <ErrorIcon />
      ) : hasWarning ? (
        <Tooltip
          title={
            <FormattedMessage
              id={`portfolio.challenge.files.add.upload_image.warnings.file_too_large.${fileRejectionState === FileRejectionState.MULTIPLE_FILES_ONE_REJECTED ? 'singular' : 'plural'}`}
            />
          }
        >
          <WarningIcon color="warning" />
        </Tooltip>
      ) : variant === 'take_photo' ? (
        <TakePhotoIcon />
      ) : variant === 'select_image' ? (
        <SelectImageIcon />
      ) : (
        <AddImageIcon />
      )}
    </ListItemIcon>
  );
};

export default ImageUploadOptionIcon;
